import { downloadCsv } from "./csv";

function safeFilenamePart(value, max = 40) {
  return String(value || "course")
    .replace(/[^\w-]+/g, "_")
    .replace(/_+/g, "_")
    .replace(/^_|_$/g, "")
    .slice(0, max);
}

function statusLabel(status) {
  if (status === "present") return "Present";
  if (status === "absent") return "Absent";
  return "";
}

function shortStatusLabel(status) {
  if (status === "present") return "P";
  if (status === "absent") return "A";
  return "";
}

/** Daily attendance CSV: Name + Status (Present/Absent). */
export function downloadDailyAttendanceCsv({
  courseTitle,
  sessionDate,
  marks,
}) {
  const rows = (marks || []).map((m) => ({
    Name: m.name || "",
    Status: statusLabel(m.status),
  }));

  const safeCourse = safeFilenamePart(courseTitle);
  const safeDate = String(sessionDate || "date").replace(/[^\d-]/g, "");
  downloadCsv(`attendance_${safeCourse}_${safeDate}.csv`, rows);
}

/**
 * Monthly attendance CSV: Name + one column per recorded class day (P / A).
 */
export function downloadMonthlyAttendanceCsv({
  courseTitle,
  year,
  month,
  dates,
  students,
}) {
  const dayHeaders = (dates || []).map((iso) => {
    const day = String(iso).slice(8, 10);
    return day.replace(/^0/, "") || day;
  });

  // Day keys like "1"/"2" are integer indexes in JS objects, so Object.keys
  // would put Name last — pass an explicit header order.
  const headers = ["Name", ...dayHeaders];
  const rows = (students || []).map((student) => {
    const row = { Name: student.name || "" };
    (student.statuses || []).forEach((status, i) => {
      const key = dayHeaders[i] || `Day ${i + 1}`;
      row[key] = shortStatusLabel(status);
    });
    return row;
  });

  const safeCourse = safeFilenamePart(courseTitle);
  const ym = `${year}-${String(month).padStart(2, "0")}`;
  downloadCsv(`attendance_monthly_${safeCourse}_${ym}.csv`, rows, headers);
}
